/* 定额数据库 页面 相关接口 */
import http from '@/assets/plugins/axios'
import {backendUrl} from '@/assets/js/config'
import queryString from 'querystring'
let headers = {'Content-type': 'application/x-www-form-urlencoded'}
export default {
  // 1. 获取所有的专业章节及地区等信息
  getMajorAndRegion (params) {
    return http.get(`${backendUrl}/data_manage/norm/catalogs`, params)
  },
  // 2. 获取所有的专业章节
  getMajorList (params) {
    return http.get(`${backendUrl}/data_manage/norm/professions`, params)
  },
  // 3. 获取编制人列表
  getAuthors (params) {
    return http.get(`${backendUrl}/data_manage/norm/authors`, params)
  },
  // 4. 根据专业章节获取地区
  getRegions (params) {
    return http.get(`${backendUrl}/data_manage/norm/regions`, params)
  },
  // 获取定额数据
  getNormList (params) {
    return http.post(`${backendUrl}/data_manage/norm/list`, params, headers)
  },
  // 移动定额数据
  moveNormData (params) {
    return http.post(`${backendUrl}/data_manage/norm/move`, params, headers)
  },
  // 9.1 获取当前定额所属的 专业章节
  getQuotaChapter (params) {
    return http.get(`${backendUrl}/data_manage/norm/chapter`, params)
  },
  // 删除定额数据
  deleteNormData (params) {
    return http.delete(`${backendUrl}/data_manage/norm`, params, headers)
  },
  // 导出定额数据
  exportNormData (params) {
    return http.post(`${backendUrl}/data_manage/norm/pre_export`, params, headers)
  },
  // 修改审查状态
  putInspect (params) {
    return http.put(`${backendUrl}/data_manage/norm/inspect`, params, headers)
  },
  // 批量审核通过
  inspectBatch (query, params) {
    return http.put(`${backendUrl}/data_manage/norm/inspect_batch?` + queryString.stringify(query), params, headers)
  },
  // 11.上传定额数据
  uploadItems (params, query) {
    return http.postArr(`${backendUrl}/data_manage/norm/upload?` + queryString.stringify(query), params, {'Content-type': 'multipart/form-data'})
  },
  // 复制定额数据
  copyNorm (params) {
    return http.post(`${backendUrl}/data_manage/norm/copy?`, params, headers)
  }
}
